import { RadioGroup } from "@headlessui/react";
import { useWarrantyVoucherData } from "app/hooks/checkout/useWarrantyVoucherData";
import { useCartContext } from "app/providers/CartProvider";
import { Fragment, useEffect, useState } from "react";
import { WarrantyPackage } from "shared/api/middleware-api-client";
import Radio, { RadioVariant } from "shared/ui/radio";
import { concatClassnames } from "shared/utils/concatClassnames";
import { WarrantyListSkeleton } from "./WarrantyListSkeleton";

export interface CheckoutWarrantyListProps {
  className?: string;
}

const CheckoutWarrantyList = ({
  className = "",
}: CheckoutWarrantyListProps) => {
  const { getCart, addWarrantyPackage, voucherWarranties } = useCartContext();
  const cart = getCart();
  const {
    voucherWarrantyPackage,
    checkoutWarranties,
    warrantyPackagesDataRequest,
    warranties,
  } = useWarrantyVoucherData({ cartValue: cart, voucherWarranties });

  const isWarrantyLoading = warrantyPackagesDataRequest.isLoading;

  const [selectedWarranty, setSelectedWarranty] = useState<
    WarrantyPackage | undefined
  >(voucherWarrantyPackage);

  useEffect(() => {
    if (voucherWarrantyPackage) {
      setSelectedWarranty(voucherWarrantyPackage);
      addWarrantyPackage(voucherWarrantyPackage);
    } else if (selectedWarranty) {
      addWarrantyPackage(selectedWarranty);
    } else if (cart.warrantyPackage) {
      setSelectedWarranty(cart.warrantyPackage);
    } else if (!cart.isSelfAssembly) {
      setSelectedWarranty(warranties.decideLaterWarrantyPackage);
    } else {
      setSelectedWarranty(warranties.noWarrantyPayNowPackage);
    }
  }, [selectedWarranty, voucherWarranties]);

  if (isWarrantyLoading) return <WarrantyListSkeleton className={className} />;

  return (
    <RadioGroup
      value={selectedWarranty}
      onChange={setSelectedWarranty}
      className={concatClassnames("gg-grid gg-gap-y-4", className)}
      disabled={!!voucherWarrantyPackage}
    >
      {checkoutWarranties.map((pkg) => {
        const packageName = pkg.packageId?.toString().toLowerCase();

        return (
          <RadioGroup.Option
            key={`warranty-${pkg.packageId}`}
            value={pkg}
            as={Fragment}
          >
            <div className="gg-flex gg-items-center gg-gap-x-5">
              <Radio
                variant={RadioVariant.CIRCLE}
                id={packageName}
                onChange={() => {}}
                checked={selectedWarranty?.packageId === pkg.packageId}
                className={"gg-shrink-0"}
                disabled={!!voucherWarrantyPackage}
              />

              <label
                htmlFor={packageName}
                className={concatClassnames("gg-align-middle")}
              >
                {pkg.name}
                {pkg.packageId !==
                  warranties.decideLaterWarrantyPackage.packageId &&
                  pkg.packageId !==
                    warranties.noWarrantyPayNowPackage.packageId && (
                    <button
                      className="gg-absolute gg-ml-1 gg-inline-block"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    ></button>
                  )}
              </label>
            </div>
          </RadioGroup.Option>
        );
      })}
    </RadioGroup>
  );
};
export default CheckoutWarrantyList;
